import { ComponentsProps } from "@material-ui/core/styles/props";

const props: ComponentsProps = {
  MuiButtonBase: {
    disableRipple: true
  }
};

export default props;
